import React from "react";
import { useComponentTranslation } from "@/services/i18n";

const translations = {
  en: {
    previous: "Previous",
    next: "Next",
    info: "Page {{current}} of {{total}}",
  },
  fr: {
    previous: "Précédent",
    next: "Suivant",
    info: "Page {{current}} sur {{total}}",
  },
};

export default function Pagination({ currentPage, total, limit, onPageChange }) {
  const { t } = useComponentTranslation(translations);

  // Support both prop interfaces
  const activePage = currentPage || 0;
  const itemsPerPage = limit || 25;
  const totalPages = Math.ceil(total / itemsPerPage);

  // Don't show pagination if there's only one page or less
  if (totalPages <= 1) return null;

  const handlePrevious = () => {
    if (onPageChange) {
      onPageChange(activePage - 1);
    }
  };

  const handleNext = () => {
    if (onPageChange) {
      onPageChange(activePage + 1);
    }
  };

  return (
    <div className="flex items-center justify-between py-4">
      <div className="flex items-center gap-2">
        <button
          onClick={handlePrevious}
          disabled={activePage === 1}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {t("previous")}
        </button>
        <span className="px-4 py-2 text-sm text-gray-600">{t("info", { current: activePage, total: totalPages })}</span>
        <button
          onClick={handleNext}
          disabled={activePage === totalPages}
          className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {t("next")}
        </button>
      </div>
    </div>
  );
}
